export default __webpack_public_path__ + "static/media/dr-madura-c.5f909d81.jpg";